import { Link } from 'react-router-dom'
import { theme } from '../../core/design-system/theme'

const styles = {
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '6px',
    padding: '12px',
    width: '110px',
    flexShrink: 0,
    background: theme.colors.card,
    border: `1px solid ${theme.colors.border}`,
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(92,61,46,0.06)',
    textDecoration: 'none',
    cursor: 'pointer',
    transition: 'box-shadow 0.15s ease, transform 0.15s ease',
  },
  avatar: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    background: `linear-gradient(135deg, ${theme.colors.terracottaLight}, ${theme.colors.terracotta})`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontFamily: theme.fonts.display,
    fontSize: '18px',
    fontWeight: 700,
    marginBottom: '2px',
  },
  name: {
    fontFamily: theme.fonts.body,
    fontSize: '12px',
    fontWeight: 700,
    color: theme.colors.textPrimary,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
  },
  stars: {
    display: 'flex',
    gap: '2px',
    alignItems: 'center',
  },
  starSvg: {
    width: '10px',
    height: '10px',
  },
  badge: {
    fontFamily: theme.fonts.body,
    fontSize: '9px',
    fontWeight: 700,
    color: theme.colors.successText,
    background: theme.colors.sageLight,
    borderRadius: '99px',
    padding: '3px 7px',
  },
}

function StarIcon({ filled }) {
  return (
    <svg viewBox="0 0 24 24" style={styles.starSvg} aria-hidden="true">
      <path
        d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
        fill={filled ? theme.colors.honeyGold : 'none'}
        stroke={theme.colors.honeyGold}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function NonnaMiniCard({ nonna }) {
  const initial = nonna.name ? nonna.name.charAt(0).toUpperCase() : '?'
  const filledStars = Math.round(nonna.rating ?? 0)

  return (
    <Link
      to={`/nonnas/${nonna.id}`}
      style={styles.card}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = '0 4px 16px rgba(92,61,46,0.12)'
        e.currentTarget.style.transform = 'translateY(-2px)'
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = '0 2px 8px rgba(92,61,46,0.06)'
        e.currentTarget.style.transform = 'translateY(0)'
      }}
      aria-label={`View ${nonna.name}'s profile`}
    >
      <div style={styles.avatar}>{initial}</div>
      <span style={styles.name}>{nonna.name}</span>
      <div style={styles.stars} aria-label={`${filledStars} out of 5 stars`}>
        {Array.from({ length: 5 }, (_, i) => (
          <StarIcon key={i} filled={i < filledStars} />
        ))}
      </div>
      <span style={styles.badge}>Vetted</span>
    </Link>
  )
}
